import * as React from "react"
import { Zoom } from "@common/components/zoom"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { ActivityIndicator, Image, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { useImageRetry } from "./useImageRetry"

const NOT_SHOWN = {
    preparing: {
        title: "Image en préparation",
        line: "Elle s'affiche dans quelques secondes.",
    },
    unreadable: {
        title: "Image illisible",
        line: "Elle ne peut pas s'afficher ici.",
    },
}

// An image the platform can't decode (a HEIC photo in Chrome, before its JPEG
// is ready) draws nothing: on the viewers' black background, that was a black
// screen. It takes the image's own style: in the paged ImageViewer, that gives
// each page its width.
function ImageNotShown({ status, style }) {
    const { title, line } = NOT_SHOWN[status]
    return (
        <View
            style={{
                flex: 1,
                ...style,
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <View
                style={{
                    alignItems: "center",
                    gap: 8,
                    padding: 20,
                    borderRadius: 10,
                    backgroundColor: theme.colors.white,
                }}
            >
                {status === "preparing" ? (
                    <ActivityIndicator color={theme.colors.grey} />
                ) : (
                    <FontAwesome5
                        name="image"
                        size={32}
                        color={theme.colors.grey}
                    />
                )}
                <TextM fontWeight="Bold" color={theme.colors.grey}>
                    {title}
                </TextM>
                <TextM
                    fontSize={12}
                    color={theme.colors.grey}
                    style={{ textAlign: "center" }}
                >
                    {line}
                </TextM>
            </View>
        </View>
    )
}

export const PinchableBox = React.forwardRef(
    ({ imageStyle, imageUri, onLayout, children, gesturesEnabled = true }, ref) => {
        const image = useImageRetry(imageUri)

        if (imageUri && image.status !== "loading") {
            return <ImageNotShown status={image.status} style={imageStyle} />
        }

        return (
            <Zoom
                ref={ref}
                gesturesEnabled={gesturesEnabled}
                style={{
                    flex: 1,
                }}
            >
                <Image
                    source={{ uri: image.uri }}
                    resizeMode="contain"
                    style={{
                        flex: 1,
                        ...imageStyle,
                    }}
                    onLayout={onLayout}
                    onError={image.onError}
                    onLoad={image.onLoad}
                />
                {children}
            </Zoom>
        )
    }
)
